export default [
  [`Размеры`, `2XS`, `XS`, `S`, `M`, `L`],
  [`Российский размер`, `40`, `42`, `44`, `46`, `48`]
];
